import type {QueryClient} from 'react-query';
import type {OrderActionsView} from './types';

/**
 * После закрытия формы чека перезапрашивает задачу на открытом экране.
 * Список берёт данные из `GET /tasks`, детальная — из `GET /tasks/:id`.
 */
export function refreshOpenedTask(
	queryClient: QueryClient,
	taskId: number,
	view: OrderActionsView,
): Promise<void> {
	if (view === 'table') {
		return queryClient.invalidateQueries(['tasks']);
	}

	return Promise.all([
		queryClient.invalidateQueries(['task', String(taskId)]),
		queryClient.invalidateQueries(['task', taskId]),
	]).then(() => undefined);
}
